import asJSONLDSnippet from './asJSONLDSnippet';

export default asJSONLDSnippet(({name, image, price, currency, inStock}) => ({
  '@context': 'http://schema.org/',
  '@type': 'Product',
  name: name,
  image: image ? [image] : [],
  offers: {
    '@type': 'Offer',
    availability: inStock ? 'http://schema.org/InStock' : 'http://schema.org/OutOfStock',
    price: price,
    priceCurrency: currency,
    seller: {
      '@type': 'Organization',
      name: 'Boosthive'
    }
  }
}));



// WEBPACK FOOTER //
// ./components/JSON-LD/JSONLDProduct.js